import { httpClient } from '@/services/http/httpClient'

export type ModuleField =
  | 'hasProjectModule'
  | 'hasOpenInnovationModule'
  | 'hasPowerBi'
  | 'hasChatbot'
  | 'hasAIService'

type ActiveModuleProps = {
  tennantId: string
  moduleField: ModuleField
}

export function activeModule({ tennantId, moduleField }: ActiveModuleProps) {
  return httpClient.post('/tennants/modules', {
    tennantId,
    moduleField,
  })
}
